import { render, staticRenderFns } from "./seckill_edit.vue?vue&type=template&id=3c07b65f&scoped=true"
import script from "./seckill_edit.vue?vue&type=script&lang=js"
export * from "./seckill_edit.vue?vue&type=script&lang=js"
import style0 from "./seckill_edit.vue?vue&type=style&index=0&id=3c07b65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07b65f",
  null
  
)

export default component.exports